import { useServices } from "./useServices.js";
const useLogger = ()=>useServices().logger;
export { useLogger };
